import { render } from "./NutritionFacts.vue?vue&type=template&id=022d8724&scoped=true"
import script from "./NutritionFacts.vue?vue&type=script&lang=js"
export * from "./NutritionFacts.vue?vue&type=script&lang=js"

import "./NutritionFacts.vue?vue&type=style&index=0&id=022d8724&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022d8724"],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/NutritionFacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "022d8724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('022d8724', __exports__)) {
    api.reload('022d8724', __exports__)
  }
  
  module.hot.accept("./NutritionFacts.vue?vue&type=template&id=022d8724&scoped=true", () => {
    api.rerender('022d8724', render)
  })

}


export default __exports__